"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M12.704 2.862c.037.474.41.613.701.614l5.743.243-6.287 6.213c-.3.302-.3.79 0 1.092.3.301.785.301 1.085 0l6.29-6.217.235 5.777c.011.25.146.765.644.738.498-.028.602-.46.592-.71L22 2.474A.502.502 0 0 0 21.53 2l-8.177.21c-.24-.03-.686.177-.649.652Zm-1.408 18.276c-.037-.474-.41-.613-.701-.614l-5.743-.243 6.287-6.213c.3-.302.3-.79 0-1.092a.764.764 0 0 0-1.085 0l-6.29 6.216-.235-5.776c-.011-.25-.146-.766-.644-.738-.498.028-.602.46-.592.71L2 21.526c.01.25.222.463.47.473l8.177-.21c.24.03.686-.177.649-.652Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};